import React from "react";

const ConfirmDialog = ({ message, cancelLabel, confirmLabel, danger, busy, onCancel, onConfirm }) => (
  <React.Fragment>
    <div className="pt-dialog-overlay" />
    <div className="pt-dialog" role="alertdialog" aria-modal="true">
      <p>{message}</p>
      <div className="pt-dialog-actions">
        <button type="button" className="pt-btn pt-btn--secondary" onClick={onCancel}>
          {cancelLabel}
        </button>
        <button
          type="button"
          className={"pt-btn " + (danger ? "pt-btn--danger" : "pt-btn--primary")}
          disabled={busy}
          onClick={onConfirm}
        >
          {busy ? <i className="fa fa-spinner fa-spin" /> : confirmLabel}
        </button>
      </div>
    </div>
  </React.Fragment>
);

export default ConfirmDialog;
